import type { VaultKind } from "@akhshy/types";

const NoteIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true">
    <path d="M3 1h6l3 3v9H3z" fill="none" stroke="currentColor" strokeWidth="1.4" />
    <path d="M9 1v3h3" fill="none" stroke="currentColor" strokeWidth="1.4" />
  </svg>
);

const LinkIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true">
    <path d="M5 2h7v7M12 2L2 12" fill="none" stroke="currentColor" strokeWidth="1.6" />
  </svg>
);

export function EntryKindLabel({ kind }: { kind: VaultKind }) {
  if (kind === "note") {
    return (
      <span className="entry-kind">
        <NoteIcon /> Note · .md
      </span>
    );
  }
  return (
    <span className="entry-kind">
      <LinkIcon /> Link · {kind}
    </span>
  );
}
